import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import { ProposedSolutionStep } from "Infrastructure/ApiZfp/Schema";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, array, bool, object, string } from "yup";
import { number } from "../Utils/schemaUtils";

export type CustomAmountCoverageFormField = {
  readonly name: string;
  readonly currentAmount: number;
  readonly recommendedAmount: number;
};

export type VehicleContractFormType = {
  readonly partnerId: string;
  readonly newPartnerId?: string;
  readonly contractAnniversaryDate?: string;
  readonly insuranceAmount?: number;
  readonly newInsuranceAmount?: number;
  readonly frequency: string;
  readonly newFrequency: string;
  readonly compulsoryInsuranceCurrentAmount?: number;
  readonly compulsoryInsuranceRecommendedAmount?: number;
  readonly cascoInsuranceCurrentValue?: boolean;
  readonly cascoInsuranceRecommendedValue?: boolean;
  readonly vehicleOtherInsuranceCurrentValue?: boolean;
  readonly vehicleOtherInsuranceRecommendedValue?: boolean;
  readonly vehicleAssistanceInsuranceCurrentValue?: boolean;
  readonly vehicleAssistanceInsuranceRecommendedValue?: boolean;
  readonly vehicleWindscreenInsuranceCurrentValue?: boolean;
  readonly vehicleWindscreenInsuranceRecommendedValue?: boolean;
  readonly proposedSolutionStepType: string;
  readonly customAmountCoverages: CustomAmountCoverageFormField[];
  readonly note?: string;
};

export const getVehicleContractFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
) => ObjectSchema<VehicleContractFormType> = (t) => {
  return object({
    partnerId: string().required(t(Resources.Validation.Required)),
    newPartnerId: string().when("proposedSolutionStepType", (proposedSolutionStepType, schema) => {
      return proposedSolutionStepType[0] === ProposedSolutionStep.keep ? schema : schema.required(t(Resources.Validation.Required));
    }),
    contractAnniversaryDate: string(),
    insuranceAmount: number(),
    newInsuranceAmount: number().when("proposedSolutionStepType", (proposedSolutionStepType, schema) => {
      return proposedSolutionStepType[0] === ProposedSolutionStep.keep ? schema : schema.required(t(Resources.Validation.Required));
    }),
    frequency: string().required(t(Resources.Validation.Required)),
    newFrequency: string().required(t(Resources.Validation.Required)),
    customAmountCoverages: array(
      object({
        name: string().required(t(Resources.Validation.Required)),
        currentAmount: number().required(t(Resources.Validation.Required)),
        recommendedAmount: number().required(t(Resources.Validation.Required)),
      }).test("at-least-one-amount", t(Resources.Validation.Required), (row) => !!(row?.currentAmount || row?.recommendedAmount)),
    ).required(t(Resources.Validation.Required)),
    proposedSolutionStepType: string().required(t(Resources.Validation.Required)),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
    compulsoryInsuranceCurrentAmount: number(),
    compulsoryInsuranceRecommendedAmount: number(),
    cascoInsuranceCurrentValue: bool(),
    cascoInsuranceRecommendedValue: bool(),
    vehicleOtherInsuranceCurrentValue: bool(),
    vehicleOtherInsuranceRecommendedValue: bool(),
    vehicleAssistanceInsuranceCurrentValue: bool(),
    vehicleAssistanceInsuranceRecommendedValue: bool(),
    vehicleWindscreenInsuranceCurrentValue: bool(),
    vehicleWindscreenInsuranceRecommendedValue: bool(),
  }).defined();
};
